import is from '@sindresorhus/is';

import type { CommentsSubject } from '../../../comments/subject/comments-subject';

type JobProfileCommentsSubjectInput = {
    architectureId: string;
    availableVersions: readonly number[];
    itemId: string;
    itemType: 'job-level' | 'job-role';
    language: string;
    requestedVersion?: number;
};

export const createJobProfileCommentsSubject = ({
    architectureId,
    availableVersions,
    itemId,
    language,
    requestedVersion,
}: JobProfileCommentsSubjectInput): CommentsSubject => {
    const isAvailable = is.number(requestedVersion) && availableVersions.includes(requestedVersion);

    return {
        architectureId,
        canCreateThreads: isAvailable,
        kind: 'job-profile',
        language,
        persistence: isAvailable ? 'persisted' : 'unavailable',
        subjectId: itemId,
        subjectVersion: is.number(requestedVersion) ? String(requestedVersion) : '0',
        transportVersion: requestedVersion ?? 0,
    };
};
